import 'bootstrap/dist/css/bootstrap.css';
// import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { Provider } from 'react-redux';
import store from './components/Store';
import Navigation from './components/Navigation';
import Home from './components/Home';
import Program from './components/Program';
import Train from './components/Train';
import Progress from './components/Progress';
import Community from './components/Community';
import About from './components/About';
import Settings from './components/Settings';
import Footer from './components/Footer';
import Disclaimer from './components/Disclaimer';
import Test from './components/Test';
import Login from './components/Login'; // Ensure Login is imported
import reportWebVitals from './reportWebVitals';
import { Amplify } from 'aws-amplify';
import config from './aws-exports';
import { AuthProvider } from './components/AuthContext'; // Import the AuthContext
import ProtectedRoute from './components/ProtectedRoute'; // Import the ProtectedRoute
import TikTokCallback from './components/TikTokCallback';
import Unsubscribe from './components/Unsubscribe';


Amplify.configure(config);

const root = ReactDOM.createRoot(document.getElementById('root'));

// Set the initial page title
document.title = 'thenics4all';

root.render(
  <Provider store={store}>
    <Router>
      <AuthProvider>
        <Navigation />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/program" element={<Program />} />
          <Route path="/train" element={<Train />} />
          <Route path="/progress" element={<Progress />} />
          <Route path="/progress/:username" element={<Progress />} />
          <Route path="/progress/:username/:levelId" element={<Progress />} />
          <Route path="/community" element={<Community />} />
          <Route path="/about" element={<About />} />
          <Route path="/disclaimer" element={<Disclaimer />} />
          <Route path="/login" element={<Login />} />
          <Route path="/test" element={<Test />} />
          <Route path="/authtiktok" element={<TikTokCallback />} />  {/* public */}
          <Route path="/unsubscribe" element={<Unsubscribe />} />

          <Route
            path="/settings"
            element={
              <ProtectedRoute>
                <Settings />
              </ProtectedRoute>
            }
          />

        </Routes>
        <Footer />
      </AuthProvider>
    </Router>
  </Provider >
);

// serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals.console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
